<div class="flex flex-col bg-white shadow-lg border border-gray-200 rounded-lg custom-blog-card mt-0 lg:mt-10">
  <div class="flex flex-col items-center" style="flex-basis: 100%">
    <div class="img-container" style="flex-basis: 45%" class="sm:flex-basis-1/4 md:flex-basis-45%">
      <a [routerLink]="['/posts']" [queryParams]="{'slug': slug}" routerLinkActive="router-link-active">
        <ng-container *ngIf="imagen !== null">
          <img class="rounded-lg w-full transform transition-transform duration-300 hover:scale-102 hover:shadow-xl" [src]="imagenPosts + imagen" alt="imagen-articulo">
        </ng-container>
      </a>
    </div>
    <div class="w-full px-4 flex flex-col justify-center h-full font-sans" style="flex-basis: 55%;">
      <!-- Título del post -->
      <a [routerLink]="['/posts']" [queryParams]="{'slug': slug}" routerLinkActive="router-link-active"
        class="flex items-center justify-center h-[30%] mt-4 mb-5">
        <h5 class="text-gray-900 blog-carousel-title-font mb-0">{{titulo}}</h5>
      </a>
    
      <!-- Resumen del post -->
      <p class="font-normal blog-carousel-text-font text-primary-dark-A300 flex-grow flex flex-col items-start h-[50%] "
        [innerHTML]='truncateHTML(resumen)'></p>
    
      <!-- Botón Leer Más -->
      <a [routerLink]="['/posts']" [queryParams]="{'slug': slug}" routerLinkActive="router-link-active" class="inline-flex items-center justify-center mb-3 text-xs font-bold text-center text-white bg-primary-700 rounded-sm
         hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 w-[134px] h-[30px]" style="flex-basis: 15%;">
        LEER MÁS
      </a>
    </div>  
  </div>
</div>